module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABQElEQVRYhe1Y0Q6DMAiEZf9t/HL2sJHVSltaiqjxEpNaEbnCoRXg4kAeEFFkHMN4RQdgxdvqABG7U0dE2LbSwUwAoK/8EBEQkWaRCCkhIhrKnIQwDcwi4U4A132l/MqIxyYSh2QgJUFEm8PsO3U85OAryP28sPK0CHaIpq7kkgFcEWihTcBS8DNwSAl5BQ9wAAHP4AGcCJSClnRhRUgbnQlXAt7BA9ygjboRAPiTqAn5lO8BhncHAnDOgPL+82bgCEzZ0PCXZQSeTX00Lk+gqgFpt6TtGNaNu/b+pohzJxrHM/86tHDvEtIgLbN01TkLfJ2v1ezzudq8mkCuAylI6TydT4MvkZRsSuMuAi0N9P4WKTUG9isRr8FcQr1iLdnnmdBiqohHs5HWea8PUwbyB7ZWr2QviV2L51soGg+BaHwAjfIGvIw5OpAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IERFSH_A.png
// module id = 74
// module chunks = 0